import React, { useContext, useCallback, useState, useMemo } from "react";
import ToggleContext from "module/toggle/context/ToggleContext";
import useEntitySync from "module/sync/useEntitySync";
import ListToolbarButton from "component/listToolbar/ListToolbarButton";
import t from "module/translations";
import PublishIcon from "@mui/icons-material/Publish";
import { useAppSelector } from "redux/hooks";
import selectEntity from "module/staff/redux/selector/selectEntity";
import ConfirmDialog from "component/confirmDialog/ConfirmDialog";

const ListToolbarSyncButtonContainer: React.FC = () => {
  const { selectedItems, setSelectedItems } = useContext(ToggleContext);
  const { sync: syncHelper } = useEntitySync();
  const selectEntityHelper = useAppSelector(selectEntity);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);

  const scheduledItemsCount = useMemo(() => {
    return selectedItems.filter((entityIdentifier) => {
      const myEntity = selectEntityHelper(entityIdentifier);
      if (
        myEntity &&
        "data" in myEntity &&
        myEntity.data &&
        "state" in myEntity.data
      ) {
        return myEntity.data.state === "scheduled";
      }

      return false;
    }).length;
  }, [selectedItems, selectEntityHelper]);

  const hasScheduledItem = scheduledItemsCount > 0;

  const handleSync = useCallback(async () => {
    await syncHelper(selectedItems);
    setSelectedItems([]);
  }, [selectedItems, setSelectedItems, syncHelper]);

  const onClick = useCallback(() => {
    if (hasScheduledItem) {
      setIsConfirmDialogOpen(true);
    } else {
      handleSync();
    }
  }, [hasScheduledItem, handleSync]);

  const onConfirm = useCallback(() => {
    setIsConfirmDialogOpen(false);
    handleSync();
  }, [handleSync]);

  const onCancel = useCallback(() => {
    setIsConfirmDialogOpen(false);
  }, []);

  return (
    <>
      <ListToolbarButton
        {...{ title: t.syncText, icon: <PublishIcon />, onClick }}
      />
      <ConfirmDialog
        {...{
          onConfirm,
          onCancel,
          isOpen: isConfirmDialogOpen,
          title: `You are attempting to upload ${scheduledItemsCount} ${
            scheduledItemsCount > 1 ? "items" : "item"
          } that ${
            scheduledItemsCount > 1 ? "are" : "is"
          } still in status "Scheduled". Would you like to proceed?`,
        }}
      />
    </>
  );
};

export default React.memo(ListToolbarSyncButtonContainer);
